<template>
  <main-content-layout
    :title="$gettext('CLIENT_UNIT')"
    :buttonTitle="$gettext('BACK')"
    :actionButton="
      () => {
        showRouter();
      }
    "
    buttonIconName="list"
  >
    <div class="tw-p-4">
      <jt-data-table
        v-if="datatable"
        :ref="'jtDataTable'"
        :api-mode="false"
        :data="registros"
        :fields="datatable.columns"
        :is-paginated="false"
        :buttons="datatable.buttons"
        noneselect
      />
    </div>
  </main-content-layout>
</template>

<script>
import ServiceRequestController from '../../../ServiceRequestController'
import { Component, Vue } from 'vue-property-decorator'
import ServiceRequesClientUnitController from './ServiceRequesClientUnitController'
import MainContentLayout from '../../../view/Layout/MainContentLayout.vue'
@Component({
  mixins: [],
  name: 'ClientUnitCard',
  components: {
    MainContentLayout
  },
  props: {
    consumerUnit: String,
    protocol: String
  }
})
class ClientUnitCard extends Vue {
  registros = [];
  datatable = null;
  controller = ServiceRequestController.getInstance();
  RegistrationInformationcontroller =
    ServiceRequesClientUnitController.getInstance();

  async mounted () {
    const { registros, datatable } =
      await this.RegistrationInformationcontroller.loadClientUnitCard(
        this.consumerUnit
      )
    this.datatable = datatable
    this.registros = registros
  }

  showRouter () {
    this.controller.routerConsumerUnit(
      {
        name: 'serviceRequest.registration-information.client-card',
        params: {
          consumerUnit: this.consumerUnit,
          protocol: this.protocol
        }
      },
      this.protocol,
      this.consumerUnit
    )
  }
}
export default ClientUnitCard
</script>

<style lang="stylus" scoped>
@import '~quasar-variables';
</style>
